import React, { useContext, useEffect } from "react";
import NavBar from "./components/common/NavBar/NavBar";
import { Outlet, useNavigate } from "react-router-dom";
import { AuthContext } from "./context/AuthContext";
import { ROUTES } from "./constants/Routes";
import axios from "axios";
import { API_ROUTES } from "./constants/API_ROUTES";
import { initFlowbite } from "flowbite";

const GuestLayout = () => {
  useEffect(() => {
    initFlowbite();
  }, []);
  return (
    <>
      <Outlet />
    </>
  );
};

export default GuestLayout;
